import React, { useState } from 'react'
import Footer from '../footer/Footer'
import "./timetable.css";
import Branch from '../search branch/Branch'
import { Helmet } from "react-helmet";
import LogoContact from '../logoContact/logoContact'
import Newnavbar from '../newNavbar/Newnavbar'
import { FaWhatsapp } from "react-icons/fa";
import axios from 'axios';

import Breadcrumbs from '../../seo/Breadcrumbs';
export default function TimeTable() {

    const branches = [
        "Thane Vardhaman", "Thane Naupada", "Thane Vartak Nagar", "Thane Vasant Vihar",
        "Thane Manpada", "Thane Hiranandani", "Thane Anand Nagar", "Kalwa",
        "Mulund Veena Nagar", "Mulund East", "Mira Road Sec.5", "MiraRoad Jangid",
        "Satara", "Bandra",
        "EDUACE GROUP TUITIONS (NAYAK'S TUTORIALS) - Mulund East",
        "EDUACE GROUP TUITIONS (NAYAK'S TUTORIALS) - Ghatkopar East",
        "EDUACE GROUP TUITIONS (NAYAK'S TUTORIALS)"
    ];

    const boards = [
        { id: 1, board: "CBSE" },
        { id: 2, board: "ICSE" },
        { id: 3, board: "SSC" },
        { id: 4, board: "IGCSE" },
        { id: 5, board: "HSC" },
    ];

    const standards = [
        { id: 8, standard: "8th" },
        { id: 9, standard: "9th" },
        { id: 10, standard: "10th" },
        { id: 11, standard: "11th" },
        { id: 12, standard: "12th" },   
    ];

    const [branch, setBranch] = useState("");
    const [board, setBoard] = useState("");
    const [std, setStd] = useState("");
    const [loading, setLoading] = useState(false); // 👈 loader state



    const handleDownload = async () => {
        if (!branch || !board || !std) {
            alert("Please select all options");
            return;
        }

        setLoading(true); // 👈 start loader

        const apiBranch = branch.toLowerCase().replace(/\s+/g, "-");
        const apiBoard = board.toLowerCase();
        const apiStd = std.replace(/th/i, "").trim();

        // Add cache-busting param 👇
        const cacheBuster = `?t=${Date.now()}`;

        const apiUrl = `https://nayakstutorials.com/admin/api/time-table/${apiBranch}/${apiBoard}/${apiStd}${cacheBuster}`;

        try {
            const resp = await fetch(apiUrl, { cache: "no-store" });

            if (!resp.ok) throw new Error(`Request failed: ${resp.status}`);

            const ct = resp.headers.get("content-type") || "";

            if (ct.includes("application/pdf")) {
                const blob = await resp.blob();
                const pdfUrl = window.URL.createObjectURL(blob);
                window.open(pdfUrl, "_blank");
                setBranch("");
                setBoard("");
                setStd("");
                setLoading(false); // 👈 stop loader

                return;
            }

            const data = await resp.json();
            if (data?.file) {
                // Add cache buster to PDF URL too 👇
                window.open(`${data.file}?v=${Date.now()}`, "_blank");
                setBranch("");
                setBoard("");
                setStd("");
                setLoading(false); // 👈 stop loader
                return;
            }

            alert("Unexpected response format");
            setLoading(false); // 👈 stop loader
        } catch (err) {
            console.error("PDF Open Error:", err);
            alert("Failed to open file. Please try again.");
            setLoading(false); // 👈 stop loader
        }
    };



    return (
        <>
            <Helmet>
                <meta charSet="utf-8" />
                <title>The Best Coaching Classes in Thane |Nayak,'s Tutorials</title>
                <meta name="title" content="The Best Coaching Classes in Thane |Nayak,'s Tutorials" />
                <meta name="description" content="Trust Thane's top coaching for your preparation. We provide a structured path to professional success, backed by experienced faculty and high pass rates." />
                <link rel="canonical" href="https://nayakstutorials.com/timetable/" />
            </Helmet>

            <div className="wpfloat">
                <LogoContact />
                <Newnavbar />
            <Breadcrumbs route="/timetable" />

                <div className="contactBackground">
                    <div className='mainPrivacy2'>
                        <h2 className="contactush2">Time-<span>Table</span></h2>

                        <div className='filterContainer'>
                            <div className='filterRow'>
                                <select value={branch} onChange={(e) => setBranch(e.target.value)}>
                                    <option value="">Select Branch</option>
                                    {branches.map((b, index) => (
                                        <option key={index} value={b}>{b}</option>
                                    ))}
                                </select>

                                <select value={board} onChange={(e) => setBoard(e.target.value)}>
                                    <option value="">Select Board</option>
                                    {boards.map((b) => (
                                        <option key={b.id} value={b.board}>{b.board}</option>
                                    ))}
                                </select>

                                <select value={std} onChange={(e) => setStd(e.target.value)}>
                                    <option value="">Select Standard</option>
                                    {standards.map((s) => (
                                        <option key={s.id} value={s.standard}>{s.standard}</option>
                                    ))}
                                </select>
                            </div>

                            <button className='downloadBtn' onClick={handleDownload}>

                                {loading ? (
                                    <>
                                        <span className="loader"></span> Opening PDF...
                                    </>
                                ) : (
                                    "View"
                                )}
                            </button>
                        </div>

                    </div>
                </div>

                <div className='contactBranch'>
                    <Branch />
                </div>

                <Footer />

                <a href="https://wa.me/+917710010044" target="_blank">
                    <div className="wpicon"><FaWhatsapp size={50} color='white' /></div>
                </a>
            </div>
        </>
    )
}
